import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Edit destination address")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Sending tokens to an incorrect address on the destination chain could result in a permanent loss of funds. ")
const _hoisted_4 = { class: "flex flex-row items-center mt-4 mb-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Address")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" An EOA address is a 42-character hexadecimal address that you can access from your wallet ")
const _hoisted_7 = {
  key: 0,
  class: "flex flex-row justify-between bg-[#434343] text-sm rounded-lg px-4 py-2"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" change ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Click to paste from clipboard")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Use sender wallet address ")
const _hoisted_11 = {
  key: 4,
  class: "flex flex-row items-center mt-1"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Using your wallet address")
const _hoisted_13 = { class: "mt-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Cancel ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_information_circle_outline = _resolveComponent("information-circle-outline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_checkmark_circle = _resolveComponent("checkmark-circle")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    show: _ctx.show,
    class: "bg-card",
    onMaskClick: _cache[4] || (_cache[4] = ($event: any) => (this.$emit('hide')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_card, { class: "w-11/12 max-w-sm" }, {
        default: _withCtx(() => [
          _createCommentVNode(" header "),
          _createVNode(_component_n_text, { class: "uppercase" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1 /* STABLE */
          }),
          _hoisted_2,
          _createVNode(_component_n_text, { class: "opacity-70 text-xs leading-3" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" label "),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_n_text, { class: "uppercase text-xs" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_n_tooltip, {
              trigger: "hover",
              class: "max-w-xs"
            }, {
              trigger: _withCtx(() => [
                _createVNode(_component_n_icon, {
                  size: "15",
                  class: "ml-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_information_circle_outline)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1 /* STABLE */
            })
          ]),
          (!_ctx.allowEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.newAddress ? _ctx.truncateAddr(_ctx.newAddress) : _ctx.truncateAddr(_ctx.destAddress)) + " ", 1 /* TEXT */),
                _createVNode(_component_n_button, {
                  text: "",
                  type: "warning",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.allowEdit = true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : (_ctx.allowPaste)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" paste address, clipboard api supported "),
                  _createElementVNode("div", {
                    class: "flex flex-row justify-center bg-[#434343] text-sm rounded-lg px-4 py-2 border border-slate-500 border-dashed cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args)))
                  }, [
                    _createVNode(_component_n_text, null, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createCommentVNode(" paste address, clipboard api NOT supported "),
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Paste address",
                    class: "flex flex-row justify-center items-center text-center w-full bg-[#434343] h-10 text-sm rounded-lg px-4 py-2 border border-slate-500 border-dashed outline-none",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.recipientInput) = $event)),
                    onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkAddr && _ctx.checkAddr(...args)))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, _ctx.recipientInput]
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
          (
          _ctx.destAddress !== _ctx.userAddress ||
          (_ctx.newAddress && _ctx.newAddress !== _ctx.userAddress)
        )
            ? (_openBlock(), _createBlock(_component_n_button, {
                key: 3,
                text: "",
                color: "#5A94E8",
                class: "mt-1 text-xs",
                onClick: _ctx.setUserAddr
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_n_icon, {
                  size: "15",
                  class: "mr-1",
                  color: "#35D07F"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_checkmark_circle)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_n_text, { class: "text-xs" }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1 /* STABLE */
                })
              ])),
          _createCommentVNode(" buttons "),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.newAddress)
              ? (_openBlock(), _createBlock(_component_n_button, {
                  key: 0,
                  color: "#5A94E8",
                  "text-color": "#fff",
                  class: "w-full mt-3 uppercase",
                  onClick: _ctx.saveAddr
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_n_button, {
              color: "#3B3B3B",
              "text-color": "#fff",
              class: "w-full mt-3 uppercase",
              onClick: _ctx.close
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}